import types from '../mutation-types';
import DealsAPI from '../../api/deals';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getDeals(_state) {
    return _state.records;
  },
  getDealsByStage: _state => stageId => {
    return _state.records.filter(deal => deal.pipeline_stage_id === stageId);
  },
  getDealById: _state => id => {
    return _state.records.find(deal => deal.id === id);
  },
};

export const actions = {
  async get({ commit }) {
    commit(types.SET_DEAL_UI_FLAG, { isFetching: true });
    try {
      const { data } = await DealsAPI.get();
      commit(types.SET_DEALS, data.payload);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_DEAL_UI_FLAG, { isFetching: false });
    }
  },

  async create({ commit }, dealParams) {
    commit(types.SET_DEAL_UI_FLAG, { isCreating: true });
    try {
      const { data } = await DealsAPI.create(dealParams);
      commit(types.ADD_DEAL, data.payload);
      return data.payload;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_DEAL_UI_FLAG, { isCreating: false });
    }
  },

  async update({ commit }, { id, ...dealParams }) {
    commit(types.SET_DEAL_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await DealsAPI.update(id, dealParams);
      commit(types.EDIT_DEAL, data.payload);
      return data.payload;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_DEAL_UI_FLAG, { isUpdating: false });
    }
  },

  async delete({ commit }, id) {
    commit(types.SET_DEAL_UI_FLAG, { isDeleting: true });
    try {
      await DealsAPI.delete(id);
      commit(types.DELETE_DEAL, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_DEAL_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_DEAL_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_DEALS](_state, records) {
    _state.records = records;
  },

  [types.ADD_DEAL](_state, record) {
    _state.records = [record, ..._state.records];
  },

  [types.EDIT_DEAL](_state, record) {
    const index = _state.records.findIndex(r => r.id === record.id);
    if (index !== -1) {
      _state.records[index] = record;
    }
  },

  [types.DELETE_DEAL](_state, id) {
    _state.records = _state.records.filter(r => r.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
